import { AuthService } from './../../../../service/auth.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { Callback } from '../../login.component';
import { AgentDto } from '../../../../service/dto';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HttpAgentService } from '../../../../service/http-agent.service';
import { concatMap, finalize } from 'rxjs';

export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	return control.value.password === control.value.confirmPassword
		? null
		: { PasswordNoMatch: true };
};

@Component({
	selector: 'app-login-forgot-password-reset',
	templateUrl: './login-forgot-password-reset.component.html',
	styleUrl: './login-forgot-password-reset.component.scss',
	standalone: false
})
export class LoginForgotPasswordResetComponent {
	@Input() agent!: AgentDto;
	@Output("doUpdateState") doUpdateState = new EventEmitter<Callback>();
	form!: FormGroup;
	submitting: boolean = false;
	showPassword = false;
	showConfirmPassword = false;
	message?: string;

	constructor(private authService: AuthService, private agentService: HttpAgentService, private fb: FormBuilder) {

	}

	ngOnInit(): void {
		this.form = this.fb.group({
			username: [this.agent.username, [Validators.required, Validators.minLength(4)]],
			password: ['', [Validators.required, Validators.minLength(4)]],
			confirmPassword: ['', [Validators.required]]
		},
			{ validators: confirmPasswordValidator }
		);
	}

	onSubmit() {
		this.agent.password = this.form.get('password')!.value;

		this.submitting = true;
		this.authService.doResetPasswordForForgotPassword(this.agent.username, this.agent.password!, this.agent.otp!).pipe(
			finalize(() => this.submitting = false)
		)
			.subscribe(result => {
				if (result.success == false) {
					this.message = result.message;
				} else {
					result.agent!.otp = this.agent.otp;
					switch (result.agent!.status) {
						case 'PendingRegistration': return this.doUpdateState.emit({ mode: 'CaptureRegistrationPortrait', agent: result.agent! });
						case 'PendingApproval': return this.doUpdateState.emit({ mode: 'PendingApproval', agent: result.agent! });
						case 'Rejected': return this.doUpdateState.emit({ mode: 'Rejected', agent: result.agent! });
						case 'Approved': return this.doUpdateState.emit({ mode: 'CapturePassword', agent: result.agent! });
						case 'Blocked': return this.doUpdateState.emit({ mode: 'Blocked', agent: result.agent! });
						case 'Suspended': return this.doUpdateState.emit({ mode: 'Suspended', agent: result.agent! });
					}
				}
			});
	}
	isInvalid(field: string): boolean {
		return !!(this.form.get(field)?.invalid && this.form.get(field)?.touched);
	}
	goBack(){
		this.doUpdateState.emit({ mode: 'CaptureUsername'});
	}
	get showPasswordsDontMatchLabel(): boolean{
		if(this.form.get('password')!.touched == false){
			return false;
		}
		if(this.form.get('confirmPassword')!.touched == false){
			return false;
		}
		const password = this.form.get('password')!.value;
		const confirmPassword = this.form.get('confirmPassword')!.value;

		return password != confirmPassword;
	}
}
